module.exports = __webpack_public_path__ + "static/img/music-bg.e5b080f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/space/music-bg.png
// module id = jl2F
// module chunks = 1